<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item> 计划任务书及相关文件 </el-breadcrumb-item>
      <el-breadcrumb-item>文件签署上传</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 搜索框 新增按钮-->
      <el-row class="row-search">
        <el-col class="el-col-user-add">
          <el-input class="user-search" clearable placeholder="请输申报书信息（用空格分隔），支持模糊搜索" v-model="query">
            <el-button slot="append" icon="el-icon-search" @click.prevent="queryProjectInfo()"></el-button>
          </el-input>
        </el-col>
      </el-row>
      <!-- 申报书列表 -->
      <el-table :data="projectInfo" style="width: 100%">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="name" label="名称" width="280"></el-table-column>
        <el-table-column prop="category" label="类别" width="280">
          <!-- <template slot-scope="scope">
            <div>{{scope.row.category}}</div>
          </template> -->
        </el-table-column>
        <el-table-column label="创建时间" width="120">
          <template slot-scope="scope">{{
            scope.row.create_time | fmtdate
          }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
              @click="showFile(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-card v-show="fileVisible">
      <div class="div-file">
        <!-- 下载模板 -->
        <div class="div-file-template">
          <h3>流程指南</h3>
          <h4>1. 下载模板。</h4>
          <h4>2. 打印模板，签字、盖章。</h4>
          <h4>3. 将签字盖章的文件扫描，转换为pdf格式后上传，纸质文件邮寄到体管中心。</h4>
        </div>
        <!-- 文件列表 -->
        <el-table :data="fileListTemplate" border style="width:551px;" :header-cell-style="{ background: '#fafafa' }">
          <el-table-column prop="name" label="文件名" width="300"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="150">
            <template slot-scope="scope">
              {{ scope.row.create_time | fmtdate }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button size="mini" :plain="true" type="primary" icon="el-icon-download" circle
                @click="downloadFile(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="div-file">
        <!-- 上传附件 -->
        <!-- 20231129注释，连同校验按钮，明年再看需求 -->
        <!-- <div>          
          <h3> 注意：</h3>
          <h3>1、《计划任务书》两种格式的文档均需上传（原始文档、pdf文档）。</h3>
          <h3>2、上传《计划任务书》文件前，请先进行预算校验，并保证页面校验的经费预算与计划任务书中的一致。</h3>
        </div>
        <div>
          <el-button type="primary" @click="editBudget()" class="el-button-add">预算校验</el-button>
        </div> -->
        <div class="div-upload">
          <input type="file" value="" class="input-upload" @change="uploadFileEdit">
          <el-button type="primary" size="small" class="button-upload">上传附件
            <i class="el-icon-upload el-icon--right"></i>
          </el-button>
        </div>
        <!-- 文件列表 -->
        <el-table :data="fileList" border style="width:551px;" :header-cell-style="{ background: '#fafafa' }">
          <el-table-column prop="name" label="文件名" width="300"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="150">
            <template slot-scope="scope">
              {{ scope.row.create_time | fmtdate }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button size="mini" :plain="true" type="primary" icon="el-icon-download" circle
                @click="downloadFile(scope.row)"></el-button>
              <el-button size="mini" :plain="true" type="danger" icon="el-icon-delete" circle
                @click="deleteFile(scope.row)">
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>

    <el-dialog title="课题经费预算" :visible.sync="budgetVisible">
      <div class="div-budget">
        <div>
          <table>
            <tr>
              <td>序号</td>
              <td>预算科目名称</td>
              <td>预算金额（万元）</td>
              <td>测算依据（另附页说明）</td>
            </tr>
            <tr>
              <td>1</td>
              <td>经费总额</td>
              <td>
                <el-input v-model="budget.f1"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s1"></el-input>
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>一、直接费用</td>
              <td>
                <el-input v-model="budget.f2"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s2"></el-input>
              </td>
            </tr>
            <tr>
              <td>3</td>
              <td>1.设备费</td>
              <td>
                <el-input v-model="budget.f3"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s3"></el-input>
              </td>
            </tr>
            <tr>
              <td>4</td>
              <td>（1）购置设备费</td>
              <td>
                <el-input v-model="budget.f4"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s4"></el-input>
              </td>
            </tr>
            <tr>
              <td>5</td>
              <td>（2）试制设备费</td>
              <td>
                <el-input v-model="budget.f5"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s5"></el-input>
              </td>
            </tr>
            <tr>
              <td>6</td>
              <td>（3）设备改造与租赁费</td>
              <td>
                <el-input v-model="budget.f6"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s6"></el-input>
              </td>
            </tr>
            <tr>
              <td>7</td>
              <td>2.材料费</td>
              <td>
                <el-input v-model="budget.f7"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s7"></el-input>
              </td>
            </tr>
            <tr>
              <td>8</td>
              <td>3.测试化验加工费</td>
              <td>
                <el-input v-model="budget.f8"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s8"></el-input>
              </td>
            </tr>
            <tr>
              <td>9</td>
              <td>4.差旅费</td>
              <td>
                <el-input v-model="budget.f9"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s9"></el-input>
              </td>
            </tr>
            <tr>
              <td>10</td>
              <td>其中：市内交通费</td>
              <td>
                <el-input v-model="budget.f10"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s10"></el-input>
              </td>
            </tr>
            <tr>
              <td>11</td>
              <td>5.会议费</td>
              <td>
                <el-input v-model="budget.f11"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s11"></el-input>
              </td>
            </tr>
            <tr>
              <td>12</td>
              <td>6.出版/印刷/文献/信息传播/知识产权事务费</td>
              <td>
                <el-input v-model="budget.f12"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s12"></el-input>
              </td>
            </tr>
            <tr>
              <td>13</td>
              <td>7.劳务费</td>
              <td>
                <el-input v-model="budget.f13"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s13"></el-input>
              </td>
            </tr>
            <tr>
              <td>14</td>
              <td>8.专家咨询费</td>
              <td>
                <el-input v-model="budget.f14"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s14"></el-input>
              </td>
            </tr>
            <tr>
              <td>15</td>
              <td>9.其他支出</td>
              <td>
                <el-input v-model="budget.f15"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s15"></el-input>
              </td>
            </tr>
            <tr>
              <td>16</td>
              <td>二、间接经费（不得超过课题经费总额的10%）</td>
              <td>
                <el-input v-model="budget.f16"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s16"></el-input>
              </td>
            </tr>
            <tr>
              <td>17</td>
              <td>1.管理费用</td>
              <td>
                <el-input v-model="budget.f17"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s17"></el-input>
              </td>
            </tr>
            <tr>
              <td>18</td>
              <td>2.绩效支出</td>
              <td>
                <el-input v-model="budget.f18"></el-input>
              </td>
              <td>
                <el-input maxlength="12" v-model="budget.s18"></el-input>
              </td>
            </tr>
          </table>

          <div class="div-but">
            <el-button type="primary" @click="budgetButton">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
//下载
import fileDownload from 'js-file-download'

export default {
  components: {},
  data() {
    return {
      userid: '',
      username: '',
      query: '', //查询条件
      projectInfo: [],
      projectInfoSelected: {}, //选中的课题
      fileVisible: false,
      fileList: [],
      fileListTemplate: [
        // {
        //   name: '（模板）保密及权属协议书.docx',
        //   path: '/static/（模板）保密及权属协议书.docx'
        // },
        // {
        //   name: '2023年计划任务书（模板）.docx',
        //   path: '/static/2023年计划任务书（模板）.docx'
        // }, {
        //   name: '信息安全及权属协议书.docx',
        //   path: '/static/信息安全及权属协议书.docx'
        // }, {
        //   name: '2023年残疾人体育专项研究课题科研团队反兴奋剂工作承诺书.docx',
        //   path: '/static/2023年残疾人体育专项研究课题科研团队反兴奋剂工作承诺书.docx'
        // },
        {
          name: '反兴奋剂工作承诺书.docx',
          path: '/static/反兴奋剂工作承诺书.docx'
        }, {
          name: '计划任务书-竞体（模板）.docx',
          path: '/static/计划任务书-竞体（模板）.docx'
        }, {
          name: '计划任务书-群体（模板）.docx',
          path: '/static/计划任务书-群体（模板）.docx'
        }, {
          name: '信息安全及权属责任书.docx',
          path: '/static/信息安全及权属责任书.docx'
        },
      ],
      // 经费校验
      budget: {}, //课题预算，初始化为null，提交时判断
      budgetVisible: false,
      budgetVerify: false,
    }
  },

  created() {
    this.userid = localStorage.getItem("userid")
    this.username = localStorage.getItem("username")
    this.getProjectInfo()
  },

  methods: {

    // 获取课题信息
    async getProjectInfo() {
      const res = await this.axios.get(`/projectInfo/?leader=${this.userid}&status=6`)
      if (res.status === 200) {
        this.projectInfo = res.data.results
      } else {
        this.$message.warning("错误")
      }
    },

    // 查询课题信息
    async queryProjectInfo() {
      const res = await this.axios.get(`/projectInfo/?leader=${this.userid}&status=6&search=${this.query}`)
      if (res.status === 200) {
        this.projectInfo = res.data.results
      } else {
        this.$message.warning("错误")
      }
    },

    // 显示文件card
    showFile(item) {
      this.fileVisible = true
      this.projectInfoSelected = item
      this.getFileList(item.pid + '/保密协议及计划任务书')
    },

    // 上传
    uploadFileEdit(e) {
      // 20231128 注释到校验，待明年打开
      // 预算不校验，不能上传
      // console.log('verify', this.budgetVerify)
      // if (!this.budgetVerify) {
      //   return this.$alert("预算校验未通过！请先进行预算校验，通过后再进行上传！")
      // }

      // if (e.target.files[0].name.slice(-3) != 'pdf') {
      //   return this.$message.error('请上传pdf格式的文件！')
      // }
      let formData = new FormData();
      // 调用后台上传接口，pid为具体路径，要加一层，防止用户查询到课题文件，误操作删除
      let pid = this.projectInfoSelected.pid + '/保密协议及计划任务书'
      let data = JSON.stringify({
        pid: pid
      })
      formData.append('file', e.target.files[0]);
      formData.append('data', data); // 上传文件的同时， 也可以上传其他数据
      let url = `/uploadFile/`;
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
      this.axios.post(url, formData, config).then((response) => {
        this.getFileList(pid)
      })
    },

    // 获取附件列表
    async getFileList(pid) {
      const res = await this.axios.get(`/fileList/?pid=${pid}`)
      if (res.status === 200) {
        this.fileList = res.data.results
      } else {
        this.$message.warning("获取文件列表错误")
      }
    },

    // 删除文件
    async deleteFile(item) {
      console.log('删除文件', item)
      let res = await this.axios.delete('/fileList/' + item.id + '/')
      if (res.status === 204) {
        this.getFileList(item.pid)
      }
      let data = {
        path: item.path
      }
      let resDelete = await this.axios.post('/deleteFile/', data)
      // console.log(resDelete)
    },

    // 下载文件
    downloadFile(item) {
      console.log('下载：', item)
      // 注意：path里带有文件名
      let url = `/downloadFile/?path=${item.path}&name=${item.name}`
      let params = {
        path: item.path,
        name: item.name
      }
      this.axios.post(url, params, {
        responseType: 'arraybuffer'
      }).then(res => {
        fileDownload(res.data, item.name)
      })
    },

    // 预算按钮
    editBudget() {
      this.budgetVisible = true;
    },
    // 预算对话框确定按钮
    budgetButton() {
      this.budgetVisible = false;

      this.budgetVerify = false

      // 判断b的各个属性，如果是undefined，则赋值为0
      let keys = ['f1', 'f2', 'f3', 'f4', 'f5', 'f6', 'f7', 'f8', 'f9', 'f10', 'f11', 'f12', 'f13', 'f14', 'f15', 'f16', 'f17'];

      keys.forEach(key => {
        if (this.budget[key] === undefined) {
          this.budget[key] = 0;
        }
      });

      let b = this.budget;

      if (parseFloat(b.f1).toFixed(4) !=
        (parseFloat(b.f2) + parseFloat(b.f16)).toFixed(4)) {
        this.budgetVisible = true;
        this.$alert("错误：经费总额 ≠ 直接经费 + 间接经费！");
      } else if (
        parseFloat(b.f2).toFixed(4) !=
        (parseFloat(b.f3) +
          parseFloat(b.f7) +
          parseFloat(b.f8) +
          parseFloat(b.f9) +
          parseFloat(b.f11) +
          parseFloat(b.f12) +
          parseFloat(b.f13) +
          parseFloat(b.f14) +
          parseFloat(b.f15)).toFixed(4)
      ) {
        let ft = parseFloat(b.f3) +
          parseFloat(b.f7) +
          parseFloat(b.f8) +
          parseFloat(b.f9) +
          parseFloat(b.f11) +
          parseFloat(b.f12) +
          parseFloat(b.f13) +
          parseFloat(b.f14) +
          parseFloat(b.f15)
        this.budgetVisible = true;
        this.$alert("错误：直接经费明细计算错误！" + '直接经费：' + parseFloat(b.f2) + '  明细总和：' + ft);
      } else if (
        parseFloat(b.f3).toFixed(4) !=
        (parseFloat(b.f4) + parseFloat(b.f5) + parseFloat(b.f6)).toFixed(4)
      ) {
        this.budgetVisible = true;
        this.$alert("错误：设备费细计算错误！");
      } else if (
        parseFloat(b.f16).toFixed(4) !=
        (parseFloat(b.f17) + parseFloat(b.f18)).toFixed(4)) {
        this.budgetVisible = true;
        this.$alert("错误：间接经费明细计算错误！");
      } else if (parseFloat(b.f1) * 0.1 < parseFloat(b.f16)) {
        this.budgetVisible = true;
        this.$alert("错误：间接经费超过了总经费的10%！");
      } else {
        // 校验通过，允许上传
        this.$alert("校验通过，可以上传文件！")
        this.budgetVerify = true
      }
    },

  },
}

</script>

<style lang="less">
.el-card {
  margin-top: 15px;
}

.header-edit {
  font-size: 18px;
  text-align: left;
  margin-bottom: 10px;
}

.el-col-user-add {
  display: flex;
}

.user-search {
  width: 420px;
  margin-right: 10px;
}

.el-col-addForm {
  display: flex;
  margin-bottom: 10px;

  span {
    display: flex;
    align-items: center;
    margin-left: 10px;
  }

  .el-input {
    width: 400px;
  }
}



.el-row-detail {
  width: 1020px;

  .el-col {
    display: flex;

    span {
      display: flex;
      align-items: center;
      margin-left: 10px;
    }

    .el-input {
      width: 200px;
    }
  }
}


.div-upload {
  width: 500px;
  padding-top: 10px;
}

.div-add {
  margin-top: 20px;
  display: flex;
  justify-content: end;
}

.div-file {
  margin-top: 15px;

  .div-file-template {
    margin-bottom: 10px;
  }

  .div-upload {
    height: 47px;

    .input-upload {
      width: 101px;
      height: 33px;
      position: absolute;
      z-index: 1;
      opacity: 0;
    }

    .button-upload {
      position: absolute;
    }

    .button-upload:hover {
      cursor: pointer;
    }
  }
}

.button-commit {
  margin-top: 20px;
}

// 预算
.div-budget {
  display: flex;
  justify-content: center;

  table {
    border-top: 1px solid #000;
    border-left: 1px solid #000;
    border-spacing: 0;
    text-align: center;
    line-height: 40px;
  }

  td {
    padding-left: 10px;
    padding-right: 10px;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
  }

  td:nth-child(2) {
    text-align: left;
  }

  .editor {
    width: 730px;
  }

  .div-but {
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/signAgreement/SignAgreement.vue